import { checkSession } from "@/api/auth";
import store from "@/store";

let pendingCheck = null;

/**
 * 校验配送后台 PHP Session 是否有效
 * @returns {Promise<boolean>}
 */
export function ensureSession() {
  if (
    store.state.authChecked &&
    store.state.isLoggedIn &&
    store.state.authUser &&
    store.state.authUser.uniacid
  ) {
    return Promise.resolve(true);
  }
  if (pendingCheck) {
    return pendingCheck;
  }

  pendingCheck = checkSession()
    .then((res) => {
      if (res && res.code === 1) {
        store.commit("setAuth", res.data || {});
        store.commit("setAuthChecked", true);
        return true;
      }
      store.commit("clearAuth");
      store.commit("setAuthChecked", true);
      return false;
    })
    .catch(() => {
      store.commit("clearAuth");
      store.commit("setAuthChecked", true);
      return false;
    })
    .finally(() => {
      pendingCheck = null;
    });

  return pendingCheck;
}

export function resetSessionCheck() {
  store.commit("setAuthChecked", false);
  pendingCheck = null;
}
